var _excluded = ["trigger", "children", "isOpen", "onOpenChange", "header", "footer", "width", "maxHeight", "isDisabled", "isReadOnly", "disableMenuShift", "disableTypeahead", "role"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from '../../utils';
import { Dropdown } from './components/Dropdown';
import { Trigger } from './components/Trigger';
import { BaseMenuContext, useBaseMenu } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseMenu = forwardRef((_ref, ref) => {
  var {
    trigger,
    children,
    isOpen,
    onOpenChange: _onOpenChange,
    header,
    footer,
    width,
    maxHeight = '296px',
    isDisabled,
    isReadOnly,
    disableMenuShift,
    disableTypeahead,
    role
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var menu = useBaseMenu({
    onOpenChange: open => {
      if (isDisabled || isReadOnly) return;

      _onOpenChange(open);
    },
    isOpen,
    width,
    disableMenuShift,
    disableTypeahead,
    role
  });
  return /*#__PURE__*/_jsxs(BaseMenuContext.Provider, {
    value: menu,
    children: [/*#__PURE__*/_jsx(Trigger, {
      ref: ref,
      trigger: trigger,
      isDisabled: isDisabled,
      isReadOnly: isReadOnly
    }), /*#__PURE__*/_jsx(Dropdown, _objectSpread(_objectSpread({
      width: width,
      maxHeight: maxHeight,
      header: header,
      footer: footer
    }, props), {}, {
      children: children
    }))]
  });
});
BaseMenu.displayName = 'BaseMenu';
//# sourceMappingURL=BaseMenu.js.map